// What a KPI period column is, as the grid states it. The column fill, the header label, the header
// tooltip and the Key modal all take their wording from here, so they cannot drift apart.
export const periodStates = {
    current: "current",
    open: "open",
    alert: "alert",
    counting: "counting",
    notCounted: "notCounted"
};

// The label at the top of each column header, above the year. A not-counted column carries no label, so the
// grid reads as the labelled columns against a plain background.
const periodStateLabels = {
    [periodStates.current]: "Current",
    [periodStates.open]: "Open",
    [periodStates.alert]: "Alert",
    [periodStates.counting]: "Counting"
};

// Each state's name and what it means for the figures. The header tooltip shows the name in bold with
// the meaning beneath; the Key modal shows the name as its row title and the meaning beneath it.
const periodStateDetails = {
    [periodStates.current]: {
        name: "Current period",
        meaning: "Still collecting. These figures can still change."
    },
    [periodStates.open]: {
        name: "Open period",
        meaning: "Figures can still change until the current period ends, then they count towards your next report."
    },
    [periodStates.counting]: {
        name: "Counting",
        meaning: "This period is closed and counts towards your next report."
    },
    [periodStates.alert]: {
        name: "Alert raised",
        meaning: "Counting starts again from the period after this one."
    },
    [periodStates.notCounted]: {
        name: "Not counted",
        meaning: "This period is closed and no longer counts towards a report."
    }
};

// The header label for a state, or null for a state that carries none.
export function periodStateLabel(state) {
    return periodStateLabels[state] ?? null;
}

export function periodStateName(state) {
    return periodStateDetails[state].name;
}

export function periodStateMeaning(state) {
    return periodStateDetails[state].meaning;
}

// The name and meaning as one sentence pair, e.g. "Counting. This period is closed...".
export function periodStateNote(state) {
    return `${periodStateName(state)}. ${periodStateMeaning(state)}`;
}
